import { FormBeps } from "../../../../../../models/Beps/beps.model";
import { Button, Col, DatePicker, Form, Input, InputNumber, Radio, Row, Select } from 'antd';
import { ChangeEvent, useEffect, useState } from "react";
import { ModalDireccion } from "../../../../../../components/ModalDireccion/ModalDireccion";
import { useLocations } from "../../../../../../hooks/useLocations";


type LocalidadProps = {
    formBeps: FormBeps,
    setFormBeps: Function,
    guardarFormulario: any,
    tab: any,
    nextTab: any,
    prevTab: any,
    actualizarFormulario: any
}

export const Localidad = ({
    formBeps,
    setFormBeps,
    guardarFormulario,
    tab,
    nextTab,
    prevTab,
    actualizarFormulario
}: LocalidadProps) => {

    const [openModal, setOpenModal] = useState(false);
    const { comunas } = useLocations();


    useEffect(() => {
        if (formBeps.con_quien_reside == 4) {
            setIsOtroQuienReside(true)
        } else {
            setIsOtroQuienReside(false)
        }

        if (formBeps.discapacidad_fisica) {
            setIsDiscapacidad(true);
        } else {
            setIsDiscapacidad(false);
        }

        if (formBeps.tipo_discapacidad == 8) {
            setIsOtraDiscapacidad(true);
        } else {
            setIsOtraDiscapacidad(false);
        }
    }, [])

    let fields = [
        { name: 'area', value: formBeps.area },
        { name: 'localidad', value: formBeps.localidad },
        { name: 'direccion', value: formBeps.direccion },
        { name: 'tiempo_residencia', value: formBeps.tiempo_residencia },
        { name: 'con_quien_reside', value: formBeps.con_quien_reside },
        { name: 'otro_con_quien_reside', value: formBeps.otro_con_quien_reside },
        { name: 'dependencia_economica', value: formBeps.dependencia_economica },
        { name: 'discapacidad_fisica', value: formBeps.discapacidad_fisica },
        { name: 'tipo_discapacidad', value: formBeps.tipo_discapacidad },
        { name: 'otra_discapacidad', value: formBeps.otra_discapacidad },
        { name: 'correo_electronico', value: formBeps.correo_electronico },
        { name: 'telefono_celular', value: formBeps.telefono_celular },
        { name: 'telefono_fijo', value: formBeps.telefono_fijo },
        { name: 'web', value: formBeps.web },
    ]

    const [isDiscapacidad, setIsDiscapacidad] = useState(false);
    const handleDiscapacidadFisica = ({ target }: any) => {
        if (target.value) {
            setIsDiscapacidad(true);
        } else {
            setIsDiscapacidad(false);
            setIsOtraDiscapacidad(false);
        }
    }

    const [isOtraDiscapacidad, setIsOtraDiscapacidad] = useState(false);
    const handleOtraDiscapacidad = (value: number) => {
        if (value == 8) {
            setIsOtraDiscapacidad(true);
        } else {
            setIsOtraDiscapacidad(false);
        }
    }


    const [isOtroQuienReside, setIsOtroQuienReside] = useState(false);
    const handleResideChange = (value: number) => {
        if (value == 4) {
            setIsOtroQuienReside(true);
        } else {
            setIsOtroQuienReside(false);
        }
    }

    return (
        <Form
            size="large"
            fields={fields}
            name="formLocalidad"
            onFieldsChange={(_, fields: any) => {
                let infoupdate: any = { ...formBeps };
                for (var i in fields) {
                    infoupdate[fields[i].name] = fields[i].value;
                }
                setFormBeps(infoupdate);
            }}
            onFinish={actualizarFormulario}
        >
            <div className="row">
                <div className="col-12 col-md-6 col-lg-3 mt-4">
                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                        Área
                    </span>
                    <Form.Item
                        className="no-margin"
                        name="area"
                        rules={[{ required: true, message: "Selecciona una zona" }]}
                    >
                        <Radio.Group value={formBeps.tipo_agente}>
                            <Radio value={1}>Urbana</Radio>
                            <Radio value={2}>Rural</Radio>
                        </Radio.Group>
                    </Form.Item>
                </div>
                { formBeps.area == 1 && (
                    <div className="col-12 col-md-6 col-lg-3 mt-4">
                        <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                            Comuna
                        </span>
                        <Form.Item
                            className="no-margin"
                            name="localidad"
                            rules={[{ required: true, message: "" }]}
                        >
                            {/* <Input
                                value={formBeps.localidad}
                            /> */}
                            <Select
                                style={{ width: "100%" }}
                                placeholder="Seleccionar..."
                                showSearch
                                filterOption={(input, option: any) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                filterSort={(optionA, optionB) =>
                                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                }
                                >
                                {comunas.map(({ id, nombre }) => (
                                    <Select.Option key={id} value={id}>
                                    {nombre}
                                    </Select.Option>
                                ))}
                                </Select>
                        </Form.Item>
                    </div> )}


                { formBeps.area == 2 && (
                    <div className="col-12 col-md-6 col-lg-3 mt-4">
                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                        Corregimientos
                    </span>
                    <Form.Item
                        className="no-margin"
                        name="localidad"
                        rules={[{ required: true, message: "" }]}
                    >
                        <Input  value={formBeps.localidad}  />
                    </Form.Item>
                    </div>
                )}

                <div className="col-12 col-md-6 col-lg-3 mt-4">
                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                        Dirección
                    </span>
                    <Form.Item
                        className="no-margin"
                        name="direccion"
                        rules={[{ required: true, message: "" }]}
                    >
                        <Input
                            maxLength={250}
                            onClick={() => setOpenModal(true)}
                            value={formBeps.direccion}
                        />
                    </Form.Item>
                </div>
                <div className="col-12 col-md-6 col-lg-3 mt-4">
                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                        Tiempo de residencia  (Años)
                    </span>
                    <Form.Item
                        className="no-margin"
                        name="tiempo_residencia"
                        rules={[{ required: true, message: "" }, {pattern: /^[1-9][0-9]*$/, message: "No se pueden ingresar valores nulos o negativos"   }]}
                    >
                        <Input
                            type="number"
                            min={1}
                            value={Number(formBeps.tiempo_residencia)}
                            pattern="^[0-9]+"
                            // min={1}
                            // max={10}
                        // suffix={<small>Años</small>}
                        />
                    </Form.Item>
                </div>
                <div className="col-12 col-md-6 col-lg-3 mt-4">
                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                        Con quien reside
                    </span>
                    <Form.Item
                        className="no-margin"
                        name="con_quien_reside"
                        rules={[{ required: true, message: "" }]}
                    >
                        <Select placeholder="Seleccionar..." value={formBeps.con_quien_reside} onChange={handleResideChange}>
                            <Select.Option value={1}>Familiar</Select.Option>
                            <Select.Option value={2}>Conyugue</Select.Option>
                            <Select.Option value={3}>Solo</Select.Option>
                            <Select.Option value={4}>Otro</Select.Option>
                        </Select>
                    </Form.Item>
                </div>
                {isOtroQuienReside &&
                    <div className="col-12 col-md-6 col-lg-3 mt-4">
                        <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                            Otro
                        </span>
                        <Form.Item
                            className="no-margin"
                            name="otro_con_quien_reside"
                            rules={[{ required: true, message: "" }]}
                        >
                            <Input
                                value={formBeps.otro_con_quien_reside}
                            />
                        </Form.Item>
                    </div>
                }
                <div className="col-12 col-md-6 col-lg-3 mt-4">
                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                        Dependencia económica
                    </span>
                    <Form.Item
                        className="no-margin"
                        name="dependencia_economica"
                        rules={[{ required: true, message: "Campo obligatorio" }]}
                    >
                        <Radio.Group value={formBeps.dependencia_economica}>
                            <Radio value={true}>Sí</Radio>
                            <Radio value={false}>No</Radio>
                        </Radio.Group>
                    </Form.Item>
                </div>
                <div className="col-12 col-md-6 col-lg-3 mt-4">
                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                        Posee discapacidad física
                    </span>
                    <Form.Item
                        className="no-margin"
                        name="discapacidad_fisica"
                        rules={[{ required: true, message: "Campo obligatorio" }]}
                    >
                        <Radio.Group value={formBeps.discapacidad_fisica} onChange={handleDiscapacidadFisica}>
                            <Radio value={true}>Sí</Radio>
                            <Radio value={false}>No</Radio>
                        </Radio.Group>
                    </Form.Item>
                </div>
                {isDiscapacidad &&
                    <div className="col-12 col-md-6 col-lg-3 mt-4">
                        <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                            Tipo discapacidad
                        </span>
                        <Form.Item
                            className="no-margin"
                            name="tipo_discapacidad"
                            rules={[{ required: true, message: "" }]}
                        >
                            <Select placeholder="Seleccionar" value={formBeps.tipo_discapacidad} onChange={handleOtraDiscapacidad}>
                                <Select.Option value={1}>Discapacidad visual</Select.Option>
                                <Select.Option value={2}>Discapacidad auditiva</Select.Option>
                                <Select.Option value={3}>Discapacidad física</Select.Option>
                                <Select.Option value={4}>Discapacidad Intelectual</Select.Option>
                                <Select.Option value={5}>Discapacidad psicosocial</Select.Option>
                                <Select.Option value={6}>Sordoceguera</Select.Option>
                                <Select.Option value={7}>Discapacidad multiple</Select.Option>
                                <Select.Option value={8}>Otra</Select.Option>
                            </Select>
                        </Form.Item>
                    </div>
                }
                {isOtraDiscapacidad &&
                    <div className="col-12 col-md-6 col-lg-3 mt-4">
                        <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                            ¿Cuál?
                        </span>
                        <Form.Item
                            className="no-margin"
                            name="otra_discapacidad"
                            rules={[{ required: true, message: "" }]}
                        >
                            <Input
                                value={formBeps.otra_discapacidad}
                            />
                        </Form.Item>
                    </div>
                }
                <div className="col-12 col-md-6 col-lg-3 mt-4">
                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                        Correo electrónico
                    </span>
                    <Form.Item
                        className="no-margin"
                        name="correo_electronico"
                        rules={[{ required: true, message: "" }, { type: 'email', message: 'No es un correo válido'}]}
                    >
                        <Input
                            maxLength={100}
                            value={formBeps.correo_electronico}
                        />
                    </Form.Item>
                </div>
                <div className="col-12 col-md-6 col-lg-3 mt-4">
                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                        Número celular
                    </span>
                    <Form.Item
                        className="no-margin"
                        name="telefono_celular"
                        rules={[{ required: true, max: 10, message: "Se requiere una longitud máxima de 10" }]}
                    >
                        <Input
                            type="number"
                            value={formBeps.telefono_celular}
                        />
                    </Form.Item>
                </div>
                <div className="col-12 col-md-6 col-lg-3 mt-4">
                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                        Web
                    </span>
                    <Form.Item
                        className="no-margin"
                        name="web"
                        rules={[{ type: "regexp",
                        pattern: new RegExp(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/
                        ),}]}
                    >
                        <Input
                            value={formBeps.web}
                        />
                    </Form.Item>
                </div>
                <div className="col-12 col-md-6 col-lg-3 mt-4">
                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                        Teléfono fijo
                    </span>
                    <Form.Item
                        className="no-margin"
                        name="telefono_fijo"
                        // rules={[{ required: true, message: "" }]}
                    >
                        <Input
                            type="number"
                            value={formBeps.telefono_fijo}
                        />
                    </Form.Item>
                </div>
            </div>

            <div className="row" style={{ position: "sticky", bottom: 0 }}>
                <div className="justify-content-flex-end">
                    <Button className="button-blanco-radius me-3" onClick={ prevTab }>Atrás</Button>
                    <Button className="button-azul-radius" form="formLocalidad" htmlType="submit">Guardar y Continuar</Button>
                </div>
            </div>

            {/* <div className="col" style={{display: 'flex', justifyContent: 'end'}}>
                <Button style={{ width: '500px'}}  type="ghost" shape="round" onClick={prevTab} >
                    Atrás
                </Button>
                <Button size="small"  type="primary" shape="round" form="formLocalidad" htmlType="submit">
                    Guardar y Continuar
                </Button>
            </div> */}

            <ModalDireccion modal={openModal} CancelarModal={() => setOpenModal(false)} AceptarModal={() => setOpenModal(false)} directions={formBeps} setDireccion={setFormBeps} namedirections="direccion" />

        </Form>
    )
}
